export default function BrandIntro() {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-white to-pink-50/30">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 bg-fuchsia-100 text-fuchsia-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-6 sm:mb-8">
          <i className="ri-sparkling-line"></i>
          <span>La marca líder en bienestar íntimo</span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 px-2">
          LELO: Innovación sueca en placer
        </h2>

        <div className="space-y-4 text-base sm:text-lg text-gray-700 leading-relaxed px-2">
          <p>
            <strong className="text-fuchsia-600">LELO</strong> es la marca sueca pionera en productos de bienestar íntimo de lujo. Con más de 15 años de innovación, ha revolucionado la industria combinando diseño escandinavo, tecnología avanzada y materiales de la más alta calidad.
          </p>
          <p>
            Galardonada con múltiples premios internacionales de diseño, LELO utiliza exclusivamente <strong>silicona de grado médico</strong>, libre de ftalatos y completamente segura para el cuerpo. Cada producto es una obra maestra de ingeniería dedicada a tu placer y salud íntima.
          </p>
          <p className="text-fuchsia-600 font-semibold">
            Porque el placer también es bienestar, y mereces lo mejor.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mt-10 sm:mt-12">
          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-full flex items-center justify-center">
              <i className="ri-award-fill text-2xl sm:text-3xl text-white"></i>
            </div>
            <p className="text-xs sm:text-sm font-semibold text-gray-800">Premiado</p>
            <p className="text-xs text-gray-600">Diseño internacional</p>
          </div>
          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-full flex items-center justify-center">
              <i className="ri-heart-pulse-fill text-2xl sm:text-3xl text-white"></i>
            </div>
            <p className="text-xs sm:text-sm font-semibold text-gray-800">Seguro</p>
            <p className="text-xs text-gray-600">Grado médico</p>
          </div>
          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-full flex items-center justify-center">
              <i className="ri-flashlight-fill text-2xl sm:text-3xl text-white"></i>
            </div>
            <p className="text-xs sm:text-sm font-semibold text-gray-800">Innovador</p>
            <p className="text-xs text-gray-600">Tecnología única</p>
          </div>
          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 bg-gradient-to-br from-fuchsia-500 to-pink-500 rounded-full flex items-center justify-center">
              <i className="ri-vip-crown-fill text-2xl sm:text-3xl text-white"></i>
            </div>
            <p className="text-xs sm:text-sm font-semibold text-gray-800">Premium</p>
            <p className="text-xs text-gray-600">Lujo sueco</p>
          </div>
        </div>
      </div>
    </section>
  );
}
